import React from 'react';
import AppLinker from './applinker';

const AppBanner = ({ backgroundColor = "header-blue", className = "" }) => {
    return (
        <div className={`${backgroundColor} row g-0 rounded-3 overflow-hidden shadow-sm ${className}`}>
            <div className="col-12 col-md-6 p-5">
                <AppLinker showDetail={false} topSpacing="0px" />
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
                <img src="/images/app_flat.png" className="img-fluid" alt="Smart" style={{ maxHeight: '300px' }} />
            </div>
        </div>
    );
};

export default AppBanner;
